import PropTypes from "prop-types"
import React from "react";

export default {
	defaultValue: PropTypes.any,
	onChange: PropTypes.func,
	onSubmit: PropTypes.func,
	schema: PropTypes.object,
	name: PropTypes.string,
};
